import { SubstituteNames } from "@components/StatsConsole/Widgets/OverviewWidget/parts/SubstituteNames";
import { EventIconAndTime } from "@components/StatsConsole/Widgets/OverviewWidget/parts/EventIconAndTime";
import { formatEventTime } from "@utils/functions";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";

interface ISubsituteEventProps {
    time: string;
    event_type: string;
    player_in: string;
    player_out: string;
    isPlusSignNeeded?: boolean;
}

export const SubstituteEventHome = ({ time, event_type, player_in, player_out, isPlusSignNeeded = false }: ISubsituteEventProps) => {
    const formattedTime = formatEventTime(time, isPlusSignNeeded);
    const substitutionEventHeightRef = useRef<HTMLDivElement>(null);
    const [containerWidth, setContainerWidth] = useState<number>(0);

    useEffect(() => {
        if (substitutionEventHeightRef.current) {
            setContainerWidth(substitutionEventHeightRef.current.offsetWidth);
        }
    }, []);

    return (
        <div data-testid="overview-substitute-event-home"
            ref={substitutionEventHeightRef} 
            className='flex justify-start mx-[16px] mb-[8px] min-h-[34px] max-h-[34px]'>
            <EventIconAndTime iconName={event_type} time={formattedTime} />
            <SubstituteNames 
                ml="8px" 
                mr="8px" 
                startPosition='start' 
                event_type={event_type} 
                player_in={player_in} 
                player_out={player_out} 
                containerWidth={containerWidth} 
            />
        </div>
    )
}

export const SubstituteEventAway = ({ time, event_type, player_in, player_out, isPlusSignNeeded = false }: ISubsituteEventProps) => {
    const formattedTime = formatEventTime(time, isPlusSignNeeded);
    const substitutionEventHeightAwayRef = useRef<HTMLDivElement>(null);
    const [containerWidth, setContainerWidth] = useState<number>(0);

    useEffect(() => {
        if (substitutionEventHeightAwayRef.current) {
            setContainerWidth(substitutionEventHeightAwayRef.current.offsetWidth);
        }
    }, []);

    return (
        <div 
            data-testid="overview-substitute-away"
            ref={substitutionEventHeightAwayRef} 
            className='flex justify-end mx-[16px] mb-[8px] min-h-[34px] max-h-[34px]'>
            <SubstituteNames 
                ml="0px" 
                mr="8px" 
                startPosition='end' 
                event_type={event_type} 
                player_in={player_in} 
                player_out={player_out} 
                containerWidth={containerWidth} 
            />
            <EventIconAndTime iconName={event_type} time={formattedTime} />
        </div>
    )
}
